/* @import '../../global/app.css'; */
@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.banner-small {
  @apply w-full h-auto rounded-[12px] relative overflow-hidden flex flex-col md:flex-row items-stretch justify-between mx-auto md:max-h-[600px] md:gap-40px md:pl-40px;
}

.banner-small-title {
  @apply fs-4 font-medium;
}

.banner-small .banner-small-content {
  @apply font-poppins w-full h-auto sm:max-w-[800px] py-[28px] px-16px md:px-0   flex-1 justify-between gap-y-[40px];
}

.banner-small .banner-small-content.banner-small-content-centered {
  @apply md:flex md:flex-col md:items-start md:justify-center md:gap-y-0;
}

.banner-small .banner-small-content .banner-small-description {
  @apply mt-[20px];
}

.banner-small .banner-small-content .button {
  @apply block;
}

.banner-small-wrapper {
  @apply pt-0 !important;
}

/* Home Banner Image Setup */
.banner-small .banner-small-asset-wrapper {
  @apply w-full h-auto block md:max-w-[45%]  md:flex md:justify-end max-h-[400px] sm:max-h-[450px] md:max-h-[100%];
}

.banner-small .banner-small-asset {
  @apply w-full h-full object-cover rounded-[12px] max-h-[355px] sm:max-h-[100%]  !important;
  aspect-ratio: 2/1;
}

.banner-small .banner-small-asset-wrapper video-block {
  @apply w-full h-full;
}

.banner-small .banner-small-asset-wrapper video-block .plyr__video-embed {
  @apply w-full h-full;
}

.banner-small .banner-small-asset-wrapper video-block .plyr__video-embed {
  @apply w-full h-full;
}

.banner-small .banner-small-asset-wrapper video-block .plyr__video-embed iframe {
  @apply w-full h-full md:min-h-[300px];
}